<template>
  <div>
    <label>{{ label }}</label>
    <div class="input-group form-check">
      <input type="checkbox"
             :class="inputClass"
             autocomplete="off"
             value="1"
             v-model="value"
             v-on:change="emitToParent()">
      <label :for="handle" :class="labelClass">{{ description }}</label>
    </div>
  </div>
</template>
<style></style>
<script>
export default {
  name: "filter-criteria-checkbox",
  props: {
    label: String,
    handle: String,
    criteriaId: Number,
    description: String,
    inputClass: String,
    labelClass: String,
    value: [ String, Boolean ]
  },
  methods: {
    emitToParent () {
      this.$emit('input', this.value)
    }
  },
  data: function () {
    return {
      value: null
    }
  }
}
</script>
